import './retrobanner.css';

function RetroBanner(){
  return(
    <>
      <h1 className='PLEASE'>GOOD 
        <span className="old">
          <span className="O-letter"> O</span>
          <span className="L-letter">L</span>
          <span className="D-letter">D </span>
        </span>
        KATY
      </h1>
    </>
  );
}

export default RetroBanner;